module.exports = __webpack_public_path__ + "img/gallery-desktop.caf54942.png";